<template>
    <div class="livechannel">
        <video
            key="1"
            ref="videoPlayerLive"
            class="player liveplayer video-js vjs-theme-dt live vjs-16-9"
            v-bind:class="{ isMobile: $isMobile() }"
        />
    </div>
</template>

<script>
// import { FadeTransition } from "vue2-transitions";
import videojs from "video.js";
// eslint-disable-next-line no-unused-vars
import videojsTracking from "videojs-event-tracking";
// eslint-disable-next-line no-unused-vars
import videoJsPlaylist from "videojs-playlist";

import "video.js/dist/video-js.css";
import "@/assets/css/video-theme.scss";

import { mapState } from "vuex";
import moment from "moment";

export default {
    name: "Player",
    components: {},
    props: {
        channel: {
            Type: Object,
            default: null
        }
    },
    computed: {
        ...mapState(["live"]),

        params() {
            if (
                typeof this.channel.channel === "undefined" &&
                typeof this.channel.id !== "undefined"
            ) {
                let index = this.live.findIndex(e => e.id === this.channel.id);
                let channel = {
                    id: this.live[index].id,
                    channel: this.live[index],
                    directHit: true
                };
                return channel;
            }

            return typeof this.channel !== "undefined" ? this.channel : null;
        },
        // dateNow: () => { return Math.floor(Date.now() / 1000)},
        customUrl() {
            return this.params.channel.url;
        },
        options() {
            return {
                aspectRatio: "16:9",
                autoplay: true,
                muted: true,
                controls: true,
                fullscreen: true,
                controlBar: {
                    fullscreenToggle: true
                },
                bufferingConfig: {
                    includeScrub: true
                },
                plugins: {
                    eventTracking: true,
                    playlist: true
                },
                sources: [
                    {
                        src: this.customUrl,
                        type: "application/x-mpegURL",
                        title: "LiveChannel"
                    }
                ]
            };
        }
    },
    data() {
        return {
            frechannel: true,
            fence: "",
            timecheck: 0,
            frametime: 0,
            diffdate: 1500,
            exptime: 0,
            current: 0,
            player: null,
            popup: true,
            closeShow: false,
            time: 0,
            interval: 60
        };
    },
    mounted() {
        this.getCredentials();
        // if (!this.player) {
        //   this.mountPlayer();
        // }
        // }
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose();
            // document.body.classList.remove("no-scroll");
        }
    },
    updated() {},
    created() {
        console.log("channel", this.channel);
    },
    methods: {
        moment: moment,
        dateformat: function(str) {
            return moment(str).format("HH:mm");
        },
        mountPlayer: function() {
            document.body.classList.add("no-scroll");

            window.xplayer = this.player = videojs(
                this.$refs.videoPlayerLive,
                this.options,
                () => {
                    this.extendPlayer();
                }
            );
            this.player.playsinline(true);

            this.player.one("tracking:firstplay", this.tracking);
            this.player.on("tracking:pause", this.tracking);
            this.player.on("tracking:seek", this.tracking);
            this.player.on("tracking:buffered", this.tracking);
            this.player.on("tracking:first-quarter", this.tracking);
            this.player.on("tracking:second-quarter", this.tracking);
            this.player.on("tracking:third-quarter", this.tracking);
            this.player.on("tracking:fourth-quarter", this.tracking);
            this.player.on("tracking:performance", this.tracking);
            this.player.on("fullscreenchange", this.fullscreenchange);
            this.player.on("useractive", () => {
                this.closeShow = true;
            });
            this.player.on("userinactive", () => {
                this.closeShow = false;
            });
            this.player.on("dispose", () => {
                console.log("dispose");
                // this.disposed()
            });
            this.player.on("updated", () => {
                console.log("updated");
                // this.disposed()
            });
            this.player.on("ended", () => {
                // this.playNext();
            });
            this.player.on("play", () => {
                this.time = 0;
                this.closeShow = true;
            });
            this.player.on("error", () => {
                console.log("PlayBack Error");

                // setTimeout(()=>{
                //   window.location.reload()
                // },1000)
            });
            this.player.on("*", this.tracking);
            this.player.on("timeupdate", this.timeupdate);
        },
        fullscreenchange: function() {
            // if (this.player.isFullscreen()) {
            //   this.player.exitFullscreen();
            // }
        },
        performance: function(data) {
            let e = {
                type: "tracking:performance",
                target: {
                    player: {
                        movie: this.options.movie
                    }
                }
            };
            this.tracking(e, data);
        },

        tracking: function() {
            //e, data
            // console.log("tracking", e, data);
        },

        timeupdate() {
            this.frametime = this.player.currentTime();

            // this.diffdate = this.channel.timer;
            if (this.channel.timer != this.exptime) {
                this.exptime = this.channel.timer;
            }
            var endDate = moment.unix(this.channel.timer);
            var startDate = moment();
            var duration = moment.duration(endDate.diff(startDate));

            this.diffdate = Math.floor(duration.asSeconds());

            if (this.timecheck < this.frametime) {
                this.timecheck = this.interval + this.frametime;
                this.$store.dispatch("FETCH_LIVE");
            }

            if (
                this.player.currentTime() < this.time ||
                this.player.currentTime() >= this.time + this.interval
            ) {
                this.time = Math.round(this.player.currentTime());
                this.$store.dispatch("liveRegPos", {
                    time: this.time,
                    id: this.params.id
                });
            }
        },

        extendPlayer() {
            var close = this.player.controlBar.addChild("button");
            var closeDom = close.el();

            close.addClass("closebutton");
            close.addClass("fal");
            close.addClass("fa-times");

            closeDom.onclick = () => {
                this.$router.go(-1);
            };
        },
        setCookie(name, value, time) {
            let expires = "; expires=" + time;
            document.cookie =
                name +
                "=" +
                (value || "") +
                expires +
                "; domain=.flixlatino.com; path=/";
        },
        getCredentials() {
            // videojs.Vhs.xhr.beforeRequest = this.beforeRequest
            this.exptime = this.channel.timer;
            if (!this.player) {
                this.mountPlayer();
            }
        }
    }
};
</script>

<style lang="scss">
.top-right-flag {
    position: absolute;
    top: 0;
    right: 0;
    padding: 1em;
    font-size: 1.3em;
}

.live .vjs-duration-display,
.live .vjs-time-divider {
    display: none;
}
.vjs-live-display {
    font-size: 1.3em;
    padding: 1.5em 0;
    color: #ff3e3e;
    font-weight: bolder;
}
.float-top {
    position: absolute;
    bottom: -3.75em;
}
.live_programming {
    position: absolute;
    bottom: 5em;
    z-index: 9999;
    width: 100%;
    pointer-events: none !important;

    .bring-to-front {
        z-index: 9999;
        pointer-events: all !important;
    }
    .container {
        max-width: 1100px;
    }

    .live_progress {
        background: #de0000;
        height: 5px;
        position: absolute;
        margin-top: -5px;
        border-radius: 10px;
    }

    span.live_title {
        position: absolute;
        padding: 0.5em;
    }
    img {
        border-radius: 5px;
    }
    .live_timing {
        font-size: 0.8em;
    }
}

.livechannel .video-js {
    width: 75% !important;
    height: 30vw !important;
    padding-top: 42%;
    margin: auto;
}

.livechannel .video-js.isMobile {
    width: 100% !important;
    height: 30vw !important;
    padding-top: 56%;
    margin: auto;
}
</style>
